<template>
  <div class="time-control">
    <i @click="leftClick" class="material-icons-outlined control-icon">keyboard_arrow_left</i>
    <span class="control-tag">
      <slot />
    </span>
    <i @click="rigthClick" class="material-icons-outlined control-icon">keyboard_arrow_right</i>
  </div>
</template>

<script>
export default {
  name: "TimeControl",
  props: {
    leftClick: {
      type: Function,
      default: () => {}
    },
    rigthClick: {
      type: Function,
      default: () => {}
    }
  }
};
</script>

<style scoped>
.time-control {
  background: #f9fafb;
  height: 2rem;
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  margin-right: 0.6rem;
  user-select: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.control-tag {
  padding: 0 0.4rem;
}
.material-icons-outlined.control-icon {
  cursor: pointer;
  padding: 1rem 0;
  transition: background-color 0.3s;
}
.material-icons-outlined.control-icon:hover {
  background: var(--color-grey);
}
</style>
